import { useEffect, useState } from "react";
import { getUpdateAvailable, subscribeUpdateAvailable } from "@/lib/versionChecker";

/** Reactive flag: `true` when a newer deployed build is available. */
export function useUpdateAvailable(): boolean {
  const [available, setAvailable] = useState<boolean>(() => getUpdateAvailable());
  useEffect(() => subscribeUpdateAvailable(setAvailable), []);
  return available;
}
